import React from "react";
import { GridRenderCellParams } from "@mui/x-data-grid";

import { formatCurrency } from "../../utils/currency";
import { PercentChangeTag } from "../PercentChangeTag";

import styles from "./TablePriceCell.module.scss";

interface ITablePriceCellProps {
  params: GridRenderCellParams<number>;
  percentChange?: number;
  reverseNegativeColors?: boolean;
}

export const TablePriceCell: React.FC<ITablePriceCellProps> = ({ params, percentChange, reverseNegativeColors }) => {
  return (
    <div className={styles.container}>
      {formatCurrency(params.value ? params.value : 0)}
      {percentChange !== undefined && (
        <PercentChangeTag value={percentChange} reverseNegativeColors={reverseNegativeColors} />
      )}
    </div>
  );
};
